import { render, staticRenderFns } from "./ComTwo.vue?vue&type=template&id=10c2091c&scoped=true&"
import script from "./ComTwo.vue?vue&type=script&lang=js&"
export * from "./ComTwo.vue?vue&type=script&lang=js&"
import style0 from "./ComTwo.vue?vue&type=style&index=0&id=10c2091c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2091c",
  null
  
)

export default component.exports